import { useCallback, useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import { trainingService } from '../../services/trainingService';
import { openSignedFile } from '../../services/fileAccess';

/**
 * Pede o PDF do certificado e o abre numa aba nova. A aba é aberta antes da chamada, ainda
 * dentro do clique, senão o bloqueador de popup engole o resultado.
 */
export function useEmitirCertificado() {
  const { enqueueSnackbar } = useSnackbar();
  const [emitindo, setEmitindo] = useState<ReadonlySet<number>>(new Set());
  // O estado só atualiza no próximo render; o ref barra o segundo clique que chega antes dele.
  const emAndamento = useRef<Set<number>>(new Set());

  const emitir = useCallback(
    async (id: number) => {
      if (emAndamento.current.has(id)) return;

      const aba = window.open('about:blank', '_blank');
      if (!aba) {
        enqueueSnackbar('Permita popups para ver o certificado', { variant: 'warning' });
        return;
      }

      emAndamento.current.add(id);
      setEmitindo(new Set(emAndamento.current));
      try {
        const { pdfPath } = await trainingService.emitirCertificado(id);
        await openSignedFile(pdfPath, aba);
      } catch (err: unknown) {
        aba.close();
        const mensagem = err instanceof Error ? err.message : 'Não foi possível emitir o certificado';
        enqueueSnackbar(mensagem, { variant: 'error' });
      } finally {
        emAndamento.current.delete(id);
        setEmitindo(new Set(emAndamento.current));
      }
    },
    [enqueueSnackbar]
  );

  return { emitindo, emitir };
}
